import {
  createContext,
  useCallback,
  useContext,
  useEffect,
  useMemo,
  useState,
} from "react";
import { IUser } from "DTO/userWorkOrderListDto";
import { userLogin, userLogout, token, userSSOLogin } from "Services/Api";

type AuthContextType = {
  user: IUser | null;
  setUser: (user: IUser | null) => void;
  login: (email: string, password: string) => Promise<boolean>;
  isFetching: boolean;
  setIsFetching: (e: boolean) => void;
  siteIsLoading: boolean;
  setSiteIsLoading: (e: boolean) => void;
  logout: () => Promise<void>;
  loginSSO: () => Promise<void>;
  /*   
    register: (payload: {
      username: string;
      email: string;
      password: string;
    }) => Promise<boolean>;
    */
};

export const AuthCtx = createContext<AuthContextType | undefined>(undefined);

export const useAuthCtx = () => {
  const ctx = useContext(AuthCtx);
  if (ctx === undefined) {
    throw new Error("Context is undefined");
  }
  return ctx;
};
export const AuthContext = ({ children }: any) => {
  const [user, setUser] = useState<IUser>(null);
  const [isFetching, setIsFetching] = useState<boolean>(false);
  const [siteIsLoading, setSiteIsLoading] = useState<boolean>(false);

  const login = useCallback(async (email: string, password: string) => {
    const data = await userLogin({
      username: email,
      password: password,
      app: "office",
    });
    if (data) {
      const user = await token();
      if (user) {
        setUser(user);
        return true;
      }
    }
    return false;
  }, []);
  const loginSSO = useCallback(async () => {
    await userSSOLogin();
  }, []);
  const fetchToken = useCallback(async () => {
    const user = await token();
    if (user) setUser(user);
    else setUser(null);
  }, []);
  /* 
    const register = useCallback(
      async (payload: {
        username: string;
        email: string;
        password: string;
      }): Promise<boolean> => {
        const res = await signUp(payload);
        setMessage({ message: res.message, status: res.success, isOpen: true });
        return res.success;
      },
      []
    );
    */
  const logout = useCallback(async () => {
    await userLogout(); // display message???
    setUser(null);
  }, []);
  useEffect(() => {
    fetchToken();
    return () => {
      setUser(null);
    };
  }, [fetchToken]);

  const val = useMemo(
    () => ({
      user,
      setUser,
      login,
      isFetching,
      setIsFetching,
      siteIsLoading,
      setSiteIsLoading,
      logout,
      loginSSO,
    }),
    [
      user,
      setUser,
      login,
      isFetching,
      setIsFetching,
      siteIsLoading,
      setSiteIsLoading,
      logout,
      loginSSO,
    ]
  );

  return <AuthCtx.Provider value={val}>{children}</AuthCtx.Provider>;
};
